import React from 'react';

const InputField = ({ label, name, value, onChange, placeholder, type = "text" }) => (
  <div className="space-y-2">
    <label htmlFor={name} className="block text-sm font-medium text-[#17171C]">
      {label}
    </label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder || `Enter ${label.toLowerCase().replace(/\s+/g, ' ')}`}
      className="h-12 w-full !rounded-xl border !border-[#E4E4E7] px-4 text-sm text-[#17171C] focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none"
    />
  </div>
);

export default InputField;